export enum LOAN_CLASS {
  CONSUMER = 1,
  COMMERCIAL = 2,
  LEASE = 3,
}

export const loanClassMap = {
  [LOAN_CLASS.CONSUMER]: 'Consumer',
  [LOAN_CLASS.COMMERCIAL]: 'Commercial',
  [LOAN_CLASS.LEASE]: 'Lease',
}

export enum LOAN_TYPE {
  PURCHASE = 1,
  REFINANCE = 2,
}

export const loanTypeMap = {
  [LOAN_TYPE.PURCHASE]: 'Purchase',
  [LOAN_TYPE.REFINANCE]: 'Refinance',
}

// loan purpose
/**
 * Deprecated: Will do a clean up in the future to use only loan class and loan type
 */
export enum LOAN_PURPOSE {
  PURCHASE = 'purchase',
  REFINCE = 'refinance',
  REFINANCE = 'refinance',
  BUSINESS = 'business',
  BUSINESS_REFINCE = 'refinanceBusiness',
  BUSINESS_REFINANCE = 'refinanceBusiness',
}

export const loanPurposeOptions = Object.values(LOAN_PURPOSE)
export type LoanPurpose = (typeof loanPurposeOptions)[number]
export const loanPurposeMap = {
  [LOAN_PURPOSE.PURCHASE]: 'Purchase',
  [LOAN_PURPOSE.REFINANCE]: 'Refinance',
  [LOAN_PURPOSE.BUSINESS]: 'Business',
  [LOAN_PURPOSE.BUSINESS_REFINANCE]: 'RefinanceBusiness',
}
export enum USER_PURPOSE {
  BUY = 'buy',
  REFINANCE = 'refinance',
  PERSONAL_LOAN = 'pl',
}

export enum CREDIT_BAND {
  POOR = 'poor',
  GOOD = 'good',
  GREAT = 'great',
  EXCELLENT = 'excellent',
}

export enum CREDIT_BUREAU {
  EQUIFAX = 'equifax',
  CENTRIX = 'centrix',
}

export enum CREDIT_SCORES_GENERATED_BY {
  SYSTEM = 1,
  BUREAU = 2,
  AGENT = 3,
  PARTNER = 4,
  BYPASS_EQUIFAX = 5,
  NEW_CREDIT_FILE = 6,
  SCORE_RULE = 7,
}

export const creditScoresGeneratedByMap = {
  [CREDIT_SCORES_GENERATED_BY.SYSTEM]: 'System',
  [CREDIT_SCORES_GENERATED_BY.BUREAU]: 'Bureau',
  [CREDIT_SCORES_GENERATED_BY.AGENT]: 'Agent',
  [CREDIT_SCORES_GENERATED_BY.PARTNER]: 'Partner',
  [CREDIT_SCORES_GENERATED_BY.BYPASS_EQUIFAX]: 'Bypass Equifax',
  [CREDIT_SCORES_GENERATED_BY.NEW_CREDIT_FILE]: 'New credit file',
  [CREDIT_SCORES_GENERATED_BY.SCORE_RULE]: 'Score rule',
}

export enum REJECTED_REASON {
  NONE = 0,
  BAD_CREDIT = 1,
  UNEMPOYMENT = 2,
  VISA = 3,
  NO_CREDIT_FILE = 4,
  // When an applicant has already applied and been declined within the last 30 days.
  ALREADY_DECLINED = 5,
}

export enum REJECTION_CODES {
  NONE = 0,
  NO_CREDIT_FILE_FOUND = 100,
  LOW_CREDIT_SCORE = 200,
  RESIDENCY_STATUS = 300,
  UNEMPLOYED = 400,
  PENSION = 500,
  TIME_OUT = 600,
  NO_OFFER = 700,
  LOW_LEAD_SCORE = 800,
  OTHER = 900,
}

// User expenses
export enum EXPENSES {
  ENTERTAINMENT = 'Entertainment',
  FOOD_GROCERIES = 'Food / Groceries',
  HEALTH_EDUCATION = 'Health / Education',
  OTHER = 'Other',
  TRANSPORT = 'Transport',
  UTILITIES = 'Utilities',
}

export const expensesMap = {
  [EXPENSES.ENTERTAINMENT]: 'expensesEntertainment',
  [EXPENSES.FOOD_GROCERIES]: 'expensesFood',
  [EXPENSES.HEALTH_EDUCATION]: 'expensesHealthEducation',
  [EXPENSES.OTHER]: 'expensesOther',
  [EXPENSES.TRANSPORT]: 'expensesTransport',
  [EXPENSES.UTILITIES]: 'expensesUtilities',
}

export const expensesFrequencyMap = {
  [EXPENSES.ENTERTAINMENT]: 'expensesEntertainmentFrequency',
  [EXPENSES.FOOD_GROCERIES]: 'expensesFoodFrequency',
  [EXPENSES.HEALTH_EDUCATION]: 'expensesHealthEducationFrequency',
  [EXPENSES.OTHER]: 'expensesOtherFrequency',
  [EXPENSES.TRANSPORT]: 'expensesTransportFrequency',
  [EXPENSES.UTILITIES]: 'expensesUtilitiesFrequency',
}

export enum PARTNER_CATEGORY {
  DEALER = 'Dealer',
  AFFILIATE = 'Affiliate',
  PAID_CHANNEL = 'Paid channel',
  REFERRAL_PARTNER = 'Referral partner',
  ORGANIC = 'Organic',
  REENGAGEMENT = 'Re-engagement',
  DIRECT = 'Direct',
}

export enum PARTNER_NAME {
  PLENTI = 'Plenti',
  RC_GUMTREE = 'RC-Gumtree',
  HENRYMONEY = 'HenryMoney',
  WHICH_CAR = 'WhichCar',
  PRICE_MY_CAR = 'PriceMyCar',
  CARS_24 = 'CARS24',
  CARS_SALES = 'carsales',
  SYDNEY_CITY_MG = 'Sydney City MG',
  PHILLIPS_AND_CO = 'Phillips and Co',
  COUNTRY_AUTOS = 'Country Autos',
  MOTORSCOUT = 'Motor Scout',
  AUTOMOBILE_GALLERY = 'Automobile Gallery',
  LANSVALE_AUTOMOTIVE = 'Lansvale Automotive',
  KINGSWOOD_CARS = 'Kingswood Cars',
  DOMS_MOTORS = 'Dom’s Motors',
  AUTOTRADERS4U = 'AutoTraders 4 U',
  GW_JACOBS = 'GW Jacobs',
  MYDRIVE_CAR_SALES = 'Mydrive Car Sales',
  LIB_AUSTRALIA = 'LIB Australia',
  HUME_WHOLESALE_CARS = 'Hume Wholesale Cars',
  GRADE_FOUR = 'Grade Four',
  PRESTIGE_CARS_CASTLE_HILL = 'Prestige Cars Castle Hill',
  MOORABBIN_CAR_SALES = 'Moorabbin Car Sales',
  ANDO_AUTO_GROUP = 'Ando Auto Group',
  JC_AUTOTRADERS = 'JC Autotraders',
  PERFECT_MOTORS = 'Perfect Motors',
  AUTO_MAX_CARS = 'Auto Max Cars',
  DOZO_CAR_SALES = 'Dozo Car Sales',
  MELBOURNE_ONLINE_MOTORS = 'Melbourne Online Motors',
  CARLY = 'Carly',
  AUTO_LOVERS_AUSTRALIA = 'Auto Lovers Australia',
  MAX_AUTOHAUS = 'Max Autohaus',
  AMS_PRO = 'AMS Pro',
  BRAAAP = 'Braaap',
  DEBT_BUSTERS = 'Debt Busters',
}

export enum PARTNER_IDS {
  PLENTI = 'a8090c95-1ae7-4540-b6eb-ca9ce37103a5',
  RC_GUMTREE = '14759f75-8803-462f-a7fa-faa7964a5c15',
  HENRYMONEY = 'b7050c95-1fx6-7w42-c6e7-ca8ce47303b7',
  WHICH_CAR = '3Mrj4LqM-p6Aa-sfAs-39vE-5I4y0me8MOSM',
  PRICE_MY_CAR = '7Qgb2Oe2-a7C2-8eB9-1A4i-7c990xe7AO4Q',
  CARS_24 = '1bQb21e7-y8A7-4eB1-W1Rv-8f014xe8AO2X',
  CARS_SALES = '4ACb21t9-c9An-5eB2-e8Rz-6f024we7B16d',
  SYDNEY_CITY_MG = 'a8d61a1a-40e1-41b0-9a5f-5b0caecf2544',
  CLEARSCORE = '90533b41-57c5-4f24-a65e-de078e3605a7',
  PHILLIPS_AND_CO = '9723eff9-a667-40d3-a91f-39a4114123f8',
  COUNTRY_AUTOS = '2408d153-d5a0-433b-8271-e85cd40ea33f',
  MOTORSCOUT = 'f26864fd-9c80-4d72-9e8e-af64c3814899',
  AUTOMOBILE_GALLERY = '55b3b444-d237-4612-9437-25b883f74051',
  LANSVALE_AUTOMOTIVE = '6fb5c1ce-0d5c-4f2a-8771-6db81886b8e7',
  KINGSWOOD_CARS = 'a6376c3f-068f-4939-8512-93b69f2d3660',
  DOMS_MOTORS = '10848a22-f42b-4683-9ded-ef93024d6d1a',
  AUTOTRADERS4U = '01b9d98e-2979-4079-bb8e-f0f0c2986ea6',
  GW_JACOBS = '38ecff2f-b37d-4624-80c0-6048a92c8ebe',
  MYDRIVE_CAR_SALES = '92ec97cf-8027-4819-950a-59e9b933a2e6',
  LIB_AUSTRALIA = 'da52c2be-5a4e-451e-b2cf-5de0742486aa',
  HUME_WHOLESALE_CARS = '96d5bb5b-bb6b-4d20-a0d9-193f89fd3009',
  GRADE_FOUR = '581e91cc-f2cb-42d6-b7d4-9f23fe4794cd',
  PRESTIGE_CARS_CASTLE_HILL = 'a656987a-4dc3-4f62-9501-56bdcfa0a268',
  MOORABBIN_CAR_SALES = 'd4d141c0-da8a-48c3-a01a-1c59a9160405',
  ANDO_AUTO_GROUP = '9411025e-1011-407e-b188-f8a5cdcdec8f',
  JC_AUTOTRADERS = '4f740b59-fe4a-4f3d-9b3e-025d3033a67e',
  PERFECT_MOTORS = '577e0083-ce38-4068-ac35-6e462a319cfb',
  AUTO_MAX_CARS = '41e4853b-eae8-4b0b-bd03-24756ebfea60',
  DOZO_CAR_SALES = 'd54b7a7d-0af2-4ddd-8dc2-ca45e7b6e181',
  MELBOURNE_ONLINE_MOTORS = 'cb5fae35-498d-42c5-9720-cc7ebb928a27',
  CARLY = 'edfa5ddc-f73a-48d0-9fac-0f4ca7b4f1f9',
  AUTO_LOVERS_AUSTRALIA = '1457ddde-10f8-403b-9d17-d7a93bd7702c',
  MAX_AUTOHAUS = 'a077a7cc-feaf-4c03-8227-d573596819b2',
  AMS_PRO = 'e4bb4093-9456-4b7a-9044-abe1de3cc13e',
  BRAAAP = 'bebb4435-6599-4b88-8d36-013d79de1d54',
  DEBT_BUSTERS = '19399555-9e1b-4840-bf2b-ddf48537f22f',
}

export const partnerNameOptions = Object.values(PARTNER_NAME)
export type PartnerName = (typeof partnerNameOptions)[number]
export const partnerNameMap = {
  [PARTNER_NAME.PLENTI]: PARTNER_IDS.PLENTI,
  [PARTNER_NAME.RC_GUMTREE]: PARTNER_IDS.RC_GUMTREE,
  [PARTNER_NAME.HENRYMONEY]: PARTNER_IDS.HENRYMONEY,
  [PARTNER_NAME.WHICH_CAR]: PARTNER_IDS.WHICH_CAR,
  [PARTNER_NAME.PRICE_MY_CAR]: PARTNER_IDS.PRICE_MY_CAR,
  [PARTNER_NAME.CARS_24]: PARTNER_IDS.CARS_24,
  [PARTNER_NAME.CARS_SALES]: PARTNER_IDS.CARS_SALES,
  [PARTNER_NAME.SYDNEY_CITY_MG]: PARTNER_IDS.SYDNEY_CITY_MG,
  [PARTNER_NAME.PHILLIPS_AND_CO]: PARTNER_IDS.PHILLIPS_AND_CO,
  [PARTNER_NAME.COUNTRY_AUTOS]: PARTNER_IDS.COUNTRY_AUTOS,
  [PARTNER_NAME.MOTORSCOUT]: PARTNER_IDS.MOTORSCOUT,
  [PARTNER_NAME.AUTOMOBILE_GALLERY]: PARTNER_IDS.AUTOMOBILE_GALLERY,
  [PARTNER_NAME.LANSVALE_AUTOMOTIVE]: PARTNER_IDS.LANSVALE_AUTOMOTIVE,
  [PARTNER_NAME.KINGSWOOD_CARS]: PARTNER_IDS.KINGSWOOD_CARS,
  [PARTNER_NAME.DOMS_MOTORS]: PARTNER_IDS.DOMS_MOTORS,
  [PARTNER_NAME.AUTOTRADERS4U]: PARTNER_IDS.AUTOTRADERS4U,
  [PARTNER_NAME.GW_JACOBS]: PARTNER_IDS.GW_JACOBS,
  [PARTNER_NAME.MYDRIVE_CAR_SALES]: PARTNER_IDS.MYDRIVE_CAR_SALES,
  [PARTNER_NAME.LIB_AUSTRALIA]: PARTNER_IDS.LIB_AUSTRALIA,
  [PARTNER_NAME.HUME_WHOLESALE_CARS]: PARTNER_IDS.HUME_WHOLESALE_CARS,
  [PARTNER_NAME.GRADE_FOUR]: PARTNER_IDS.GRADE_FOUR,
  [PARTNER_NAME.PRESTIGE_CARS_CASTLE_HILL]: PARTNER_IDS.PRESTIGE_CARS_CASTLE_HILL,
  [PARTNER_NAME.MOORABBIN_CAR_SALES]: PARTNER_IDS.MOORABBIN_CAR_SALES,
  [PARTNER_NAME.ANDO_AUTO_GROUP]: PARTNER_IDS.ANDO_AUTO_GROUP,
  [PARTNER_NAME.JC_AUTOTRADERS]: PARTNER_IDS.JC_AUTOTRADERS,
  [PARTNER_NAME.PERFECT_MOTORS]: PARTNER_IDS.PERFECT_MOTORS,
  [PARTNER_NAME.AUTO_MAX_CARS]: PARTNER_IDS.AUTO_MAX_CARS,
  [PARTNER_NAME.DOZO_CAR_SALES]: PARTNER_IDS.DOZO_CAR_SALES,
  [PARTNER_NAME.MELBOURNE_ONLINE_MOTORS]: PARTNER_IDS.MELBOURNE_ONLINE_MOTORS,
  [PARTNER_NAME.CARLY]: PARTNER_IDS.CARLY,
  [PARTNER_NAME.AUTO_LOVERS_AUSTRALIA]: PARTNER_IDS.AUTO_LOVERS_AUSTRALIA,
  [PARTNER_NAME.MAX_AUTOHAUS]: PARTNER_IDS.MAX_AUTOHAUS,
  [PARTNER_NAME.AMS_PRO]: PARTNER_IDS.AMS_PRO,
  [PARTNER_NAME.BRAAAP]: PARTNER_IDS.BRAAAP,
  [PARTNER_NAME.DEBT_BUSTERS]: PARTNER_IDS.DEBT_BUSTERS,
}

/**
 * @deprecated Use LOAN_APPLICATION_STATUS instead
 */
export enum APPLICATION_STATUS {
  IN_PROGRESS = 1,
  AWAITING_DOCUMENTS = 2,
  UNDER_REVIEW = 3,
  LODGED = 4,
  PRE_APPROVED = 5,
  SETTLED = 6,
  WITHDRAWN = 7,
  DECLINED = 8,
}

export const applicationStatusToText = {
  [APPLICATION_STATUS.IN_PROGRESS]: 'in progress',
  [APPLICATION_STATUS.AWAITING_DOCUMENTS]: 'awaiting documents',
  [APPLICATION_STATUS.UNDER_REVIEW]: 'under review',
  [APPLICATION_STATUS.LODGED]: 'lodged',
  [APPLICATION_STATUS.PRE_APPROVED]: 'pre-approved',
  [APPLICATION_STATUS.SETTLED]: 'settled',
  [APPLICATION_STATUS.DECLINED]: 'declined',
  [APPLICATION_STATUS.WITHDRAWN]: 'withdrawn',
}

// Replacement for removed APPLICATION_STATUS above.
export enum LOAN_APPLICATION_STATUS {
  PARTIAL = 50,
  RECEIVED = 100,
  QUOTED = 200,
  STARTED = 300,
  AWAITING_DOCUMENTS = 400,
  UNDER_REVIEW = 500,
  LODGED = 600,
  CONDITIONALLY_APPROVED = 700,
  APPROVED = 800,
  SETTLED = 900,
  WITHDRAWN = 930,
  DECLINED = 950,
  REFERRED = 960,
  CLOSED = 970,
}

export enum LOAN_APPLICATION_SUB_STATUS {
  CALL_1_MADE = 'Call 1 Made',
  CALL_2_MADE = 'Call 2 Made',
  FOLLOW_UP_DATE = 'Follow up Date',
  CHASE = 'Chase',
  CORRESPONDENCE_RECEIVED = 'Correspondence Received',
  AWAITING_CUSTOMER_RESPONSE = 'Awaiting Customer Response',
  REQUIRES_DRIVA_ACTION = 'Requires Driva Action',
  FOLLOW_UP_DATE_SET = 'Follow up Date Set',
  DECLINATURE_SENT = 'Declinature Sent',
  SETTLEMENT_IN_PROGRESS = 'Settlement in Progress',
  SETTLED = 'Settled',
  WITHDRAWN = 'Withdrawn',
  READY_FOR_LODGEMENT = 'Ready for Lodgement',
  COLD_LEAD = 'Cold Lead',
  WITHDRAW_REQUEST = 'Withdraw Request',
  DOCUMENT_RECEIVED = 'Document Received',
}

export const REFERRAL_LOAN_PARTNER_STATUS = {
  UNDER_ASSESSMENT: 'Under Assessment',
  PARTNER_NOT_ASSIGNED: 'Partner Not Assigned',
  PARTNER_ASSIGNED: 'Partner Assigned',
  CUSTOMER_PENDING: 'Customer Pending',
  REFERRAL_SENT_TO_PARTNER: 'Referral Sent To Partner',
  REFERRAL_TO_PARTNER_SUCCESS: 'Referral To Partner Success',
  REFERRAL_TO_PARTNER_FAILED: 'Referral To Partner Failed',
  REFERRAL_IN_PARTNER_DECLINED: 'Referral In Partner Declined',
  REFERRAL_IN_PARTNER_WITHDRAWN: 'Referral In Partner Withdrawn',
  REFERRAL_IN_PARTNER_APPROVED: 'Referral In Partner Approved',
  REFERRAL_IN_PARTNER_SETTLED: 'Referral In Partner Settled',
}

export const LOAN_APPLICATION_STATUS_TEXT = {
  [LOAN_APPLICATION_STATUS.PARTIAL]: 'Partial',
  [LOAN_APPLICATION_STATUS.RECEIVED]: 'Received',
  [LOAN_APPLICATION_STATUS.QUOTED]: 'Quoted',
  [LOAN_APPLICATION_STATUS.STARTED]: 'Started',
  [LOAN_APPLICATION_STATUS.AWAITING_DOCUMENTS]: 'Awaiting documents',
  [LOAN_APPLICATION_STATUS.UNDER_REVIEW]: 'Under review',
  [LOAN_APPLICATION_STATUS.LODGED]: 'Lodged',
  [LOAN_APPLICATION_STATUS.CONDITIONALLY_APPROVED]: 'Conditionally approved',
  [LOAN_APPLICATION_STATUS.APPROVED]: 'Approved',
  [LOAN_APPLICATION_STATUS.SETTLED]: 'Settled',
  [LOAN_APPLICATION_STATUS.WITHDRAWN]: 'Withdrawn',
  [LOAN_APPLICATION_STATUS.DECLINED]: 'Declined',
  [LOAN_APPLICATION_STATUS.REFERRED]: 'Referred',
  [LOAN_APPLICATION_STATUS.CLOSED]: 'Closed',
}

export enum APPLICATION_STEP {
  Initial = 0,
  VehicleLookup = 1,
  Employment = 2,
  Expenses = 3,
  Assets = 4,
  Liabilities = 5,
  Submit = 6,
  ApplicationDocs = 7,
  PostApprovalDocs = 8,
  Dashboard = 9,
  Guarantor = 10,
  PersonalDetails = 11,
  // Sits between VehicleLookup and Employment in the flow, but takes the next free value —
  // the earlier values are persisted on loan_application.step and cannot be renumbered.
  Situation = 12,
}

export enum APPLICATION_STEP_NAME {
  INITIAL = 'Initial',
  VEHICLE_LOOKUP = 'VehicleLookup',
  EMPLOYMENT = 'Employment',
  EXPENSES = 'Expenses',
  ASSETS = 'Assets',
  LIABILITIES = 'Liabilities',
  SUBMIT = 'Submit',
  APPLICATION_DOCS = 'ApplicationDocs',
  POST_APPROVAL_DOCS = 'PostApprovalDocs',
  DASHBOARD = 'Dashboard',
  GUARANTOR = 'Guarantor',
  PERSONAL_DETAILS = 'PersonalDetails',
  SITUATION = 'Situation',
}

export const applicationStepToText = {
  [APPLICATION_STEP.Initial]: APPLICATION_STEP_NAME.INITIAL,
  [APPLICATION_STEP.VehicleLookup]: APPLICATION_STEP_NAME.VEHICLE_LOOKUP,
  [APPLICATION_STEP.Employment]: APPLICATION_STEP_NAME.EMPLOYMENT,
  [APPLICATION_STEP.Expenses]: APPLICATION_STEP_NAME.EXPENSES,
  [APPLICATION_STEP.Assets]: APPLICATION_STEP_NAME.ASSETS,
  [APPLICATION_STEP.Liabilities]: APPLICATION_STEP_NAME.LIABILITIES,
  [APPLICATION_STEP.Submit]: APPLICATION_STEP_NAME.SUBMIT,
  [APPLICATION_STEP.ApplicationDocs]: APPLICATION_STEP_NAME.APPLICATION_DOCS,
  [APPLICATION_STEP.PostApprovalDocs]: APPLICATION_STEP_NAME.POST_APPROVAL_DOCS,
  [APPLICATION_STEP.Dashboard]: APPLICATION_STEP_NAME.DASHBOARD,
  [APPLICATION_STEP.Guarantor]: APPLICATION_STEP_NAME.GUARANTOR,
  [APPLICATION_STEP.PersonalDetails]: APPLICATION_STEP_NAME.PERSONAL_DETAILS,
  [APPLICATION_STEP.Situation]: APPLICATION_STEP_NAME.SITUATION,
}

export const applicationStepToUrl = {
  [APPLICATION_STEP.Initial]: 'initial',
  [APPLICATION_STEP.PersonalDetails]: 'about-you',
  [APPLICATION_STEP.VehicleLookup]: 'vehicle-lookup',
  [APPLICATION_STEP.Situation]: 'situation',
  [APPLICATION_STEP.Employment]: 'employment',
  [APPLICATION_STEP.Expenses]: 'expenses',
  [APPLICATION_STEP.Assets]: 'assets',
  [APPLICATION_STEP.Liabilities]: 'liabilities',
  [APPLICATION_STEP.Submit]: 'submit',
  [APPLICATION_STEP.ApplicationDocs]: 'applicationdocs',
  [APPLICATION_STEP.PostApprovalDocs]: 'postapprovaldocs',
  [APPLICATION_STEP.Dashboard]: 'dashboard',
  [APPLICATION_STEP.Guarantor]: 'guarantor',
}

export enum APPLICATION_DOCUMENTS {
  NOTICE_OF_ASSESSMENT = 'noticeOfAssessment',
  NOTICE_OF_ASSESSMENT_2 = 'noticeOfAssessment2',
  MOST_RECENT_TAX_RETURN = 'mostRecentTaxReturn',
  SECOND_MOST_RECENT_TAX_RETURN = 'secondMostRecentTaxReturn',
  FRONT_OF_DRIVERS_LICENCE = 'driversLicenseFront',
  BACK_OF_DRIVERS_LICENCE = 'driversLicenseBack',
  DRIVING_LICENCE_FRONT_UK = 'drivingLicenceFrontUK',
  DRIVING_LICENCE_BACK_UK = 'drivingLicenceBackUK',
  MOST_RECENT_PAYSLIP = 'payslipOne',
  SECOND_MOST_RECENT_PAYSLIP = 'payslipTwo',
  BANK_STATEMENTS = 'bankstatements',
  MANUAL_UPLOADED_BANK_STATEMENTS = 'manualUploadedBankstatements',
  RENTAL_LEDGER = 'rentalLedger',
  CHILD_SUPPORT_ASSESSMENT = 'childSupportAssessment',
  CENTRELINK_INCOME_STATEMENTS = 'centrelinkIncomeStatements',
  TENANCY_AGREEMENT = 'tenancyAgreement',
  PARTNER_DECLARED_INCOME = 'partnerDeclaredIncome',
  MOST_RECENT_PARTNER_PAYSLIP = 'mostRecentPartnerPayslip',
  MEDICARE = 'medicare',
  PRIVACY_POLICY = 'privacyPolicy',
  SALES_INVOICE = 'salesInvoice',
  INSURANCE_CERTIFICATE = 'insuranceCertificate',
  OTHER = 'other',
  TRUST_DEED = 'trustDeed',
  THREE_MONTH_BANK_STATEMENTS = '3MonthsRecentBankStatements',
  SELLER_DEALER_DETAILS = 'sellerDealerDetails',
  FRONT_OF_PHOTO_ID = 'frontOfPhotoID',
  BACK_OF_PHOTO_ID = 'backOfPhotoID',
  CREDIT_FILE = 'creditFile',
  PASSPORT = 'passport',
  LODGEMENT_FORM = 'lodgementForm',
  CONTRACT_EMAIL = 'contractEmail',
  CONTRACT_DYNAMIC_DOC = 'contractDynamicDoc',
  LENDER_INVOICE = 'lenderInvoice',
}

export enum LENDER_REQUESTED_DOCUMENTS {
  MOST_RECENT_PAYSLIP = 'mostRecentPayslip',
  SECOND_MOST_RECENT_PAYSLIP = 'secondMostRecentPayslip',
}

export enum APPLICATION_CATEGORY {
  APPLICATION_DOCUMENTS = 1,
  POST_APPROVAL_DOCUMENTS = 2,
  DESK_ONLY_DOCUMENTS = 3,
}

export const APPLICATION_CATEGORY_MAPPING = {
  [APPLICATION_CATEGORY.APPLICATION_DOCUMENTS]: [
    APPLICATION_DOCUMENTS.NOTICE_OF_ASSESSMENT,
    APPLICATION_DOCUMENTS.MOST_RECENT_TAX_RETURN,
    APPLICATION_DOCUMENTS.FRONT_OF_DRIVERS_LICENCE,
    APPLICATION_DOCUMENTS.BACK_OF_DRIVERS_LICENCE,
    APPLICATION_DOCUMENTS.MOST_RECENT_PAYSLIP,
    APPLICATION_DOCUMENTS.SECOND_MOST_RECENT_PAYSLIP,
    APPLICATION_DOCUMENTS.BANK_STATEMENTS,
    APPLICATION_DOCUMENTS.MANUAL_UPLOADED_BANK_STATEMENTS,
    APPLICATION_DOCUMENTS.TRUST_DEED,
  ],
  [APPLICATION_CATEGORY.POST_APPROVAL_DOCUMENTS]: [
    APPLICATION_DOCUMENTS.RENTAL_LEDGER,
    APPLICATION_DOCUMENTS.CHILD_SUPPORT_ASSESSMENT,
    APPLICATION_DOCUMENTS.CENTRELINK_INCOME_STATEMENTS,
    APPLICATION_DOCUMENTS.TENANCY_AGREEMENT,
    APPLICATION_DOCUMENTS.PARTNER_DECLARED_INCOME,
    APPLICATION_DOCUMENTS.MOST_RECENT_PARTNER_PAYSLIP,
    APPLICATION_DOCUMENTS.MEDICARE,
    APPLICATION_DOCUMENTS.PRIVACY_POLICY,
    APPLICATION_DOCUMENTS.SALES_INVOICE,
    APPLICATION_DOCUMENTS.INSURANCE_CERTIFICATE,
  ],
  [APPLICATION_CATEGORY.DESK_ONLY_DOCUMENTS]: [
    APPLICATION_DOCUMENTS.OTHER,
    APPLICATION_DOCUMENTS.CONTRACT_EMAIL,
    APPLICATION_DOCUMENTS.CONTRACT_DYNAMIC_DOC,
  ],
}

export enum COMPANY_TYPES {
  SOLE_TRADER = 'soleTrader',
  TRUST = 'trust',
  PRIVATE_LIMITED = 'ptyLtd',
  LIMITED = 'ltd',
  PUBLIC_COMPANY = 'Public Company',
  PARTNERSHIP = 'Partnership',
}

export enum STATE_FULL_NAMES {
  'new south wales' = 'NSW',
  queensland = 'QLD',
  'northern territory' = 'NT',
  'western australia' = 'WA',
  'south australia' = 'SA',
  victoria = 'VIC',
  'australian capital territory' = 'ACT',
  tasmania = 'TAS',
}

export enum META_NAMES {
  REQUEST_CONTACT = 'requestContact',
  ZENDESK_TICKET_ID = 'zendeskTicketId',
  DOCUSIGN_AGREEMENT_ID = 'docuSignAgreementId',
  SALESFORCE_CASE_ID = 'salesforceCaseId',
  SALESFORCE_CASEOWNER_ID = 'salesforceCaseOwnerId',
  SALESFORCE_CASE_MANAGER_ID = 'salesforceCaseManagerId',
  SALESFORCE_CASE_MANAGER_NAME = 'salesforceCaseManagerName',
  SALESFORCE_CONTACT_ID = 'salesforceContactId',
  CARS_24_CHECKOUT = 'cars24Checkout',
  IS_FINANCE_FIRST = 'isFinanceFirst',
  WARRANTY_FINANCED = 'warrantyFinanced',
  SALESFORCE_ACCOUNT_ID = 'salesforceAccountId',
  TURBO_DOCS = 'turboDocs',
  VERIFIER_ACCEPTTERMS = 'verifier.acceptterms',
  AUTO_LENDER_SWITCH = 'autoLenderSwitch',
  AUTO_LENDER_SWITCH_CONFIRMED = 'autoLenderSwitchConfirmed',
  AUTO_ASSESSMENT = 'autoAssessment',
  AUTO_ASSESSMENT_STARTED = 'autoAssessmentStarted',
  AUTO_ASSESSMENT_STATUS = 'autoAssessmentStatus',
  AUTO_ASSESSMENT_ORIGINAL_INPUT_ID = 'autoAssessmentOriginalInputId',
  AUTO_ASSESSMENT_COMPLETE_INPUT_ID = 'autoAssessmentCompleteInputId',
  AUTO_ASSESSMENT_CREDIT_INPUT_ID = 'autoAssessmentCreditInputId',
  DYNAMIC_POPUP = 'dynamicPopup',
  APP_DOC_COMPLETED_POPUP = 'appDocCompletedPopup',
  APP_DOC_POPUP = 'appDocPopup',
  LINK_SOURCE = 'linkSource',
  IS_LENDER_SELECTED_FROM_QUOTE_PAGE = 'isLenderSelectedFromQuotePage',
  PRICING_API_SHOW_LOGO_POPUP = 'PricingApiShowLogoPopup',
  CHECKOUT_DATE = 'checkoutDate',
  IS_ENQUIRED_VEHICLE = 'isEnquiredVehicle',
  VEHICLE_REFERRAL = 'vehicleReferral',
  SUCCESSFUL_VEHICLE_REFERRAL = 'successfulVehicleReferral',
  TRAFFIC_SOURCE = 'trafficSource',
  GCLID = 'gclid',
  FBCLID = 'fbclid',
  FIRST_SOURCE_ATTRIBUTION = 'firstSourceAttribution',
  FIRST_SOURCE_ATTRIBUTION_OTHER = 'firstSourceAttributionOther',
  EQUIFAX_SCORE_SEEKER_EXPERIMENT = 'experiment.scoreseeker',
  REFERRAL_PARTNER = 'referralPartner',
  IS_SHOW_APP_PERSONAL_DETAILS = 'isShowAppPersonalDetails',
  DECLINE_REFER_DISABLED = 'declineReferDisabled',
  IS_SKIP_CREDIT_SCORE_CUT_OFF = 'isSkipCreditScoreCutoff',
  WITHDRAWN_DECLINED_REASON = 'withdrawnDeclinedReason',
  PLENTI_PL_RATE_ESTIMATE_COMPLETED = 'PlentiPlRateEstimateCompleted',
  PLENTI_PL_RATE_ESTIMATE_STARTED = 'plentiPlRateEstimateStarted',
  DASH_PARTIAL_COMPLETED = 'dashPartialCompleted',
  DASH_INSTANT_QUOTE_VIEWED = 'dashInstantQuoteViewed',
  LOAN_AMOUNT_ADJUSTED = 'loanAmountAdjusted',
  SYSTEM_AUTO_CLOSE_REASON = 'systemAutoCloseReason',
  DUPLICATE_PARTNER_APP_ACTION = 'duplicatePartnerAppAction',
  DECLINED_DUE_TO_LEAD_SCORE_CUTOFF = 'declinedDueToLeadScoreCutoff',
  API_HANDOVER_MODAL_COMPLETED = 'apiHandoverModalCompleted',
  BYPASSED_EQUIFAX = 'bypassedEquifax', // Not used
  EQUIFAX = 'equifaxEnquiryId',
  EQUIFAX_RATELIMIT = 'equifaxRateLimit',
  EQUIFAX_GET_SCORES_LIMIT = 'equifaxGetScoresLimit',
  DOCUSIGN = 'docuSignAgreementId',
  CARS_24_DELIVERY = 'cars24Delivery',
  CARS_24_CANCELLATION = 'cars24Cancellation',
  ZENDESK = 'zendeskTicketId',
  BROKERAGE_FEE_EXPERIMENT = 'brokerageFeeExperiment',
  IS_MANUAL_LENDER_SWITCH = 'isManualLenderSwitch',
  IS_STANDARD_DOCS_COMPLETED = 'isStandardDocumentsCompleted',
  IS_SUPPORTING_DOCS_COMPLETED = 'isSupportingDocumentsCompleted',
  LENDER_APP_ID = 'lenderAppId',
  BYPASSED_CENTRIX = 'bypassedCentrix',
  CENTRIX = 'centrix',
  CENTRIX_RATELIMIT = 'centrixRateLimit',
  GENERATED_QUOTE_STATUS = 'generatedQuoteStatus',
  DOB_VERIFICATION_REMAINING_ATTEMPTS = 'DOBVerificationRemainingAttempts',
  CATCH_E_DRIVER_ID = 'catchEDriverId',
  IS_SKIP_BANK_STATEMENTS = 'isSkipBankStatements',
  APPLIED_SUGGESTION_LOAN_AMOUNT_INPUT_ID = 'appliedSuggestionLoanAmountInputId',
  MONEY_PLACE_QUOTE_ID = 'moneyPlaceQuoteId',
  SMART_LODGEMENT_ENGINE_STATUS = 'smartLodgementEngineStatus',
  IS_SMART_LODGEMENT_ENGINE_PROCESSED = 'isSmartLodgementEngineProcessed',
  PRE_APPROVAL_LENDER_CLICK_THROUGHS_UK = 'preApprovalLenderClickThroughsUK',
  SALESFORCE_SUB_STATUS = 'salesforceSubstatus',
  IS_SUB_STATUS_CR_EVER = 'isSubstatusCrEver',
  CARMOOLA_APPLICATION_ID = 'carMoolaApplicationId',
  IS_INCOME_VERIFIED = 'isIncomeVerified',
}

export enum NOTE_VISIBILITY {
  PUBLIC = 0,
  PRIVATE = 1,
}

/** Types of popups */
export type Popups =
  | META_NAMES.DYNAMIC_POPUP
  | META_NAMES.APP_DOC_COMPLETED_POPUP
  | META_NAMES.APP_DOC_POPUP
  | META_NAMES.PRICING_API_SHOW_LOGO_POPUP

export enum HTTP_STATUS_CODE {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  NETWORK_CONNECT_TIMEOUT_ERROR = 599,
}

/* Capture purchase intent */
export enum PURCHASE_INTENT {
  ASAP = 'asap',
  WITHIN_A_MONTH = 'withinAMonth',
  NO_HURRY = 'noHurry',
  NOT_SURE = 'notSure',
}

export const PURCHASE_INTENT_TO_TEXT = {
  [PURCHASE_INTENT.ASAP]: 'ASAP',
  [PURCHASE_INTENT.WITHIN_A_MONTH]: 'Within a month',
  [PURCHASE_INTENT.NO_HURRY]: 'No hurry',
  [PURCHASE_INTENT.NOT_SURE]: 'Not sure',
}

export enum PURCHASE_STAGE {
  FIGURING_OUT_BUDGET = 'figuring_out_budget',
  DECIDING_MAKE_MODEL = 'deciding_make_model',
  HAVE_MAKE_MODEL = 'have_make_model',
  FOUND_EXACT_VEHICLE = 'found_exact_vehicle',
}

export const PURCHASE_STAGE_TO_TEXT = {
  [PURCHASE_STAGE.FIGURING_OUT_BUDGET]: 'Figuring out my budget',
  [PURCHASE_STAGE.DECIDING_MAKE_MODEL]: 'Deciding on a make and model',
  [PURCHASE_STAGE.HAVE_MAKE_MODEL]: 'Have a make and model in mind',
  [PURCHASE_STAGE.FOUND_EXACT_VEHICLE]: 'Found an exact vehicle and ready to buy',
}

export enum SALESFORCE_WITHDRAWN_DECLINED_REASON {
  WD_OFFERED_MORE_COMPETITIVE_RATE = 'WD - Offered more competitive rate',
  WD_CHANGE_IN_CIRCUMSTANCE = 'WD - Change in circumstance',
  WD_INTEREST_RATE_TOO_HIGH = 'WD - Interest rate too high',
  WD_FEES_TOO_HIGH = 'WD - Fees too high',
  WD_UNWILLING_TO_PROVIDE_DOCS_INFO = 'WD - Unwilling to provide docs / info',
  WD_SECURITY_PRIVACY_CONCERNS = 'WD - Security / privacy concerns',
  WD_DELAYED_DELIVERY = 'WD - Delayed delivery',
  WD_COUNTER_OFFER = 'WD - Counter offer',
  WD_UNABLE_TO_FIND_VEHICLE = 'WD - Unable to find vehicle',
  WD_NO_LONGER_USING_FINANCE = 'WD - No longer using finance',
  WD_DISCONTENT_WITH_TAT = 'WD - Discontent with TAT',
  BS_PAYDAY_EARLY_WAGE_ACTIVITY = 'BS - Pay day / early wage activity',
  BS_GAMBLING = 'BS - Gambling',
  BS_ATM_WITHDRAWALS = 'BS - ATM Withdrawals',
  BS_DISHONOURS = 'BS - Dishonours',
  BS_DAYS_IN_NEGATIVE = 'BS - Days in Negative',
  BS_SAME_DAY_CLEARANCE = 'BS - Same day clearance',
  BS_OTHER_CONDUCT = 'BS - Other conduct',
  CF_LATE_PAYMENTS_RECENT = 'CF - Late Payments (recent)',
  CF_DEFAULTS_RECENT = 'CF - Defaults (recent)',
  CF_ACTIVE_FILE = 'CF - Active file',
  CF_FINANCIAL_HARDSHIP = 'CF - Financial hardship',
  CF_OTHER_CONDUCT = 'CF - Other conduct',
  OTHER_LOAN_PURPOSE = 'Other - Loan Purpose',
  OTHER_INSUFFICIENT_EMPLOYMENT_HISTORY = 'Other - Insufficient employment history',
  OTHER_RECENT_DRAWDOWN = 'Other - Recent drawdown',
  OTHER_INSUFFICIENT_ABN = 'Other - Insufficient ABN',
  OTHER_NO_SECURABLE_ASSET = 'Other - No securable asset',
  OTHER_RESIDENCY = 'Other - Residency',
  OTHER_NO_SERVICING_CAPACITY = 'Other - No Servicing Capacity',
  FRAUD = 'Fraud',
  SYSTEM = 'System',
}

export enum SQS_QUEUE_ACTION_TYPES {
  ADD_CONTACT_TAG = 'addContactTag',
  REFER_LEAD = 'referLead',
  PRELIMINARY_ASSESSMENT = 'preliminaryAssessment',
  UNARCHIVE_APPLICATION_FILES = 'unarchiveApplicationFiles',
  SYNC_SALESFORCE = 'syncSalesforce',
  AUDIT_PRECHECK = 'auditPrecheck',
  AUDIT_BUILD_FOLDER = 'auditBuildFolder',
  PULL_CREDIT_FILE = 'pullCreditFile',
}

export enum LOAN_OPTION_PRICING_REQUEST_SOURCE {
  DASH_IQ = 'dash-iq',
  AUTO_ASSESSMENT = 'auto-assessment',
  SALESFORCE_RECALCULATE = 'salesforce-recalculate',
  DASH_RECALCULATE = 'dash-recalculate',
  AUTO_ASSESSMENT_CREDIT_FILE_READY = 'auto-assessment-credit-file-ready',
  API_READ_ONLY_PL = 'api-read-only-pl',
}

export enum REQUEST_SOURCE {
  DASH = 'dash',
}

export enum NON_ELIGIBILITY_CODE {
  LOW_CREDIT_SCORE = 100,
  RESIDENCY_STATUS = 101,
  BELOW_MINIMUM_AGE = 102,
  NO_CREDIT_FILE = 103,
  LOW_CREDIT_FILE_AGE = 104,
  BELOW_GROSS_INCOME_LIMIT = 105,
  VEHICLE_AGE_START = 200,
  EXCEEDS_VEHICLE_AGE_LIMIT = 201,
  VEHICLE_AGE_END = 300,
  BELOW_MINIMUM_LOAN_AMOUNT = 400,
  NON_VALID_PARTNER = 401,
  EXCEEDS_MAXIMUM_LOAN_AMOUNT = 500,
  EXCEEDS_MAXIMUM_LOAN_TERM = 501,
  EXCEEDS_MAXIMUM_LOAN_AMOUNT_FOR_TIER_3 = 502,
  BELOW_MINIMUM_ABN = 503,
  BELOW_MINIMUM_GST = 504,
  DEALER_ONLY = 600,
  NOT_WITHIN_EMPLOYMENT = 700,
  REFINANCE_NOT_ALLOWED = 701,
  COMMERCIAL_REFINANCE_NOT_ALLOWED = 702,
  NOT_WITHIN_BUSINESS_DURATION = 703,
  CARS_ONLY = 800,
  MOTOR_BIKE_NO_PRIVATE_SALE = 801,
  CARAVAN_NEEDS_ASSET_BACKED = 802,
  NO_REFINANCE = 900,
  EXCEEDS_CREDIT_ENQUIRIES_LIMIT = 901,
  EXCEEDS_DAYS_IN_NEGATIVE_LIMIT = 902,
  EXCEEDS_DEBT_COLLECTION_NINETY_DAYS_LIMIT = 903,
  EXCEEDS_DEFAULT_JUDGEMENT_LIMIT = 904,
  EXCEEDS_GAMBLING_LIMIT = 905,
  EXCEEDS_RHI_TWELVE_MONTHS_LIMIT = 906,
  EXCEEDS_RHI_TWENTY_FOUR_MONTHS_LIMIT = 907,
  EXCEEDS_DISHONOURS_LIMIT = 908,
  EXCEEDS_OUTSTANDING_FINANCIAL_LIMIT = 909,
  EXCEEDS_OUTSTANDING_FINANCIAL_LAST_YEAR_LIMIT = 910,
  EXCEEDS_PAYDAY_ACCOUNT_IN_THIRTY_DAYS_LIMIT = 911,
  EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_LIMIT = 912,
  EXCEEDS_PAYDAY_ENQUIRIES_LIMIT = 913,
  EXCEEDS_PAID_FINANCIAL_DEFAULT_LIMIT = 914,
  EXCEEDS_PAID_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT = 915,
  EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LIMIT = 916,
  EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT = 917,
  BELOW_SERVICEABILITY_LIMIT = 918,
  WARRANTY_FINANCE_NOTSUPPORTED = 919,
  EXCEEDS_RHI_THREE_MONTHS_LIMIT = 920,
  EXCEEDS_PAYDAY_ENQUIRIES_IN_SIX_MONTHS_LIMIT = 921,
  EXCEEDS_PAYDAY_ENQUIRIES_IN_TWELVE_MONTHS_LIMIT = 922,
  EXCEEDS_PAYDAY_ENQUIRIES_IN_TWENTY_FOUR_MONTHS_LIMIT = 923,
  EXCEEDS_POSSIBLE_MATCH_LIMIT = 924,
  EXCEEDS_OUTSTANDING_NON_FINANCIAL_LIMIT = 925,
  NO_PERSONAL_LOAN = 926,
  EXCEEDS_DISHONOURS_LIMIT_IN_THIRTY_DAYS_LIMIT = 927,
  EXCEEDS_DEBT_CONSOLIDATION_LIMIT = 928,
  EXCEEDS_DEBT_MANAGEMENT_LIMIT = 929,
  NOT_WITHIN_THIN_FILE_LIMIT = 930,
  EXCEEDS_BNPL_LIMIT = 931,
  EXCEEDS_ATM_WTIHDRAWALS = 932,
  EXCEEDS_ATM_WTIHDRAWALS_PERCENT_INCOME = 933,
  EXCEEDS_COMMERCIAL_DEFAULTS_IN_SIX_MONTHS = 934,
  EXCEEDS_FINANCIAL_DEFAULTS_IN_SIX_MONTHS = 935,
  EXCEEDS_FINANCIAL_HARDSHIP_INDICATOR = 936,
  NOT_WITHIN_INCOME_VERIFICATION = 937,
  NOT_WITHIN_MINIMUM_NET_INCOME = 938,
  EXCEEDS_NO_OF_OPEN_CREDIT_CARDS = 939,
  EXCEEDS_NO_OF_OPEN_PERSONAL_LOANS = 940,
  EXCEEDS_NO_OF_OPEN_VEHICLE_LOANS = 941,
  EXCEEDS_NO_OF_OPEN_MORTGAGES = 942,
  EXCEEDS_NON_FINANCIAL_DEFAULTS_IN_SIX_MONTHS = 943,
  EXCEEDS_OUTSTANDING_COMMERCIAL_DEFAULT = 944,
  EXCEEDS_OUTSTANDING_DEFAULT_JUDGEMENT = 945,
  EXCEEDS_PAID_COMMERCIAL_DEFAULTS = 946,
  EXCEEDS_PAID_COMMERCIAL_DEFAULTS_IN_TWELVE_MONTHS = 947,
  EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_DRAWDOWNS_INCLUSIVE = 948,
  EXCEEDS_PAID_DEFAULT_JUDGEMENTS = 949,
  EXCEEDS_PAID_DEFAULT_JUDGEMENTS_IN_TWELVE_MONTHS = 950,
  EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_SIXTY_DAYS = 951,
  EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_NINETY_DAYS = 952,
  NOT_WITHIN_SECURABLE_ASSET = 953,
  EXCEEDS_FINANCIAL_DISHONOURS_IN_NINETY_DAYS = 954,
  EXCEEDS_FINANCIAL_DISHONOURS_IN_THIRTY_DAYS = 955,
  EXCEEDS_EWF_CONDITIONS = 956,
  EXCEEDS_COMPLIANCE_CONDITIONS = 957,
  INTERNAL = 1000,
}

export const NON_ELIGIBILITY_REASON = {
  [NON_ELIGIBILITY_CODE.LOW_CREDIT_SCORE]: 'Credit score is too low',
  [NON_ELIGIBILITY_CODE.RESIDENCY_STATUS]: 'Visas not accepted',
  [NON_ELIGIBILITY_CODE.BELOW_MINIMUM_AGE]: 'Did not meet the minimum age criteria',
  [NON_ELIGIBILITY_CODE.NO_CREDIT_FILE]: 'Insufficient credit history',
  [NON_ELIGIBILITY_CODE.LOW_CREDIT_FILE_AGE]: 'Below minimum credit file age limit',
  [NON_ELIGIBILITY_CODE.BELOW_GROSS_INCOME_LIMIT]: 'Below minimum gross income limit',
  [NON_ELIGIBILITY_CODE.VEHICLE_AGE_START]: 'Vehicle age too old',
  [NON_ELIGIBILITY_CODE.EXCEEDS_VEHICLE_AGE_LIMIT]: 'Exceeds vehicle age limit',
  [NON_ELIGIBILITY_CODE.VEHICLE_AGE_END]: 'Vehicle age too old given length of loan',
  [NON_ELIGIBILITY_CODE.BELOW_MINIMUM_LOAN_AMOUNT]: 'Below lender minimum loan amount',
  [NON_ELIGIBILITY_CODE.EXCEEDS_MAXIMUM_LOAN_AMOUNT]: 'Exceeds lender maximum loan amount',
  [NON_ELIGIBILITY_CODE.EXCEEDS_MAXIMUM_LOAN_TERM]: 'Exceeds lender maximum loan term',
  [NON_ELIGIBILITY_CODE.EXCEEDS_MAXIMUM_LOAN_AMOUNT_FOR_TIER_3]: 'Exceeds lender maximum loan amount',
  [NON_ELIGIBILITY_CODE.BELOW_MINIMUM_ABN]: 'Below minimum required ABN registration period',
  [NON_ELIGIBILITY_CODE.BELOW_MINIMUM_GST]: 'Below minimum required GST registration period',
  [NON_ELIGIBILITY_CODE.DEALER_ONLY]: 'Dealer sales only',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_EMPLOYMENT]: 'Not within lender employment policies',
  [NON_ELIGIBILITY_CODE.REFINANCE_NOT_ALLOWED]: 'Refinance not available',
  [NON_ELIGIBILITY_CODE.COMMERCIAL_REFINANCE_NOT_ALLOWED]: 'Refinance not available',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_BUSINESS_DURATION]: 'Not within business registration and duration policies',
  [NON_ELIGIBILITY_CODE.CARS_ONLY]: 'Not available for the chosen asset class',
  [NON_ELIGIBILITY_CODE.MOTOR_BIKE_NO_PRIVATE_SALE]: 'Dealer sales only for motorbikes',
  [NON_ELIGIBILITY_CODE.CARAVAN_NEEDS_ASSET_BACKED]: 'Not available for the chosen asset class',
  [NON_ELIGIBILITY_CODE.NO_REFINANCE]: 'Refinancing not available',
  [NON_ELIGIBILITY_CODE.EXCEEDS_CREDIT_ENQUIRIES_LIMIT]: 'Exceeds credit enquiries limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DAYS_IN_NEGATIVE_LIMIT]: 'Exceeds days in negative limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_COLLECTION_NINETY_DAYS_LIMIT]: 'Exceeds debt collection limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DEFAULT_JUDGEMENT_LIMIT]: 'Exceeds default judgement limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_GAMBLING_LIMIT]: 'Exceeds gambling limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_RHI_THREE_MONTHS_LIMIT]: 'Exceeds RHI status in the last 3 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_RHI_TWELVE_MONTHS_LIMIT]: 'Exceeds RHI status in the last 12 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_RHI_TWENTY_FOUR_MONTHS_LIMIT]: 'Exceeds RHI status in the last 24 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DISHONOURS_LIMIT]: 'Exceeds dishonours limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_FINANCIAL_LIMIT]: 'Exceeds outstanding financial limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_FINANCIAL_LAST_YEAR_LIMIT]: 'Exceeds outstanding financial last year limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_NON_FINANCIAL_LIMIT]: 'Exceeds outstanding non-financial limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_THIRTY_DAYS_LIMIT]: 'Exceeds payday account in 30 days limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_LIMIT]: 'Exceeds payday account in 90 days limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_SIX_MONTHS_LIMIT]: 'Exceeds payday enquiries in 6 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_TWELVE_MONTHS_LIMIT]: 'Exceeds payday enquiries in 12 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_TWENTY_FOUR_MONTHS_LIMIT]:
    'Exceeds payday enquiries in 24 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_LIMIT]: 'Exceeds payday enquiries limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_FINANCIAL_DEFAULT_LIMIT]: 'Exceeds paid financial default limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT]:
    'Exceeds paid financial default last year limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LIMIT]: 'Exceeds paid non-financial default limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT]:
    'Exceeds paid non-financial default last year limit',
  [NON_ELIGIBILITY_CODE.BELOW_SERVICEABILITY_LIMIT]: 'Below serviceability limit',
  [NON_ELIGIBILITY_CODE.WARRANTY_FINANCE_NOTSUPPORTED]: 'Warranty Finance not supported',
  [NON_ELIGIBILITY_CODE.NON_VALID_PARTNER]: 'No offer available',
  [NON_ELIGIBILITY_CODE.INTERNAL]: 'No offer available',
  [NON_ELIGIBILITY_CODE.EXCEEDS_POSSIBLE_MATCH_LIMIT]: 'Exceeds possible match limit',
  [NON_ELIGIBILITY_CODE.NO_PERSONAL_LOAN]: 'No offer available',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DISHONOURS_LIMIT_IN_THIRTY_DAYS_LIMIT]: 'Exceeds dishonours limit in 30 days',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_CONSOLIDATION_LIMIT]: 'No offer available',
  [NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_MANAGEMENT_LIMIT]: 'No offer available',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_THIN_FILE_LIMIT]: 'No offer available',
  [NON_ELIGIBILITY_CODE.EXCEEDS_BNPL_LIMIT]: 'Exceeds BNPL activity limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_ATM_WTIHDRAWALS]: 'Exceeds ATM withdrawals limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_ATM_WTIHDRAWALS_PERCENT_INCOME]:
    'Exceeds ATM withdrawals as a percentage of income limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_COMMERCIAL_DEFAULTS_IN_SIX_MONTHS]: 'Exceeds commercial defaults in 6 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DEFAULTS_IN_SIX_MONTHS]: 'Exceeds financial defaults in 6 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_HARDSHIP_INDICATOR]: 'Exceeds financial hardship indicator limit',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_INCOME_VERIFICATION]: 'Not within income verification limit',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_MINIMUM_NET_INCOME]: 'Not within minimum net income limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_CREDIT_CARDS]: 'Exceeds number of open credit cards limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_PERSONAL_LOANS]: 'Exceeds number of open personal loans limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_VEHICLE_LOANS]: 'Exceeds number of open vehicle loans limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_MORTGAGES]: 'Exceeds number of open mortgages limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_NON_FINANCIAL_DEFAULTS_IN_SIX_MONTHS]:
    'Exceeds non-financial defaults in 6 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_COMMERCIAL_DEFAULT]: 'Exceeds outstanding commercial default limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_DEFAULT_JUDGEMENT]: 'Exceeds outstanding default judgement limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_COMMERCIAL_DEFAULTS]: 'Exceeds paid commercial defaults limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_COMMERCIAL_DEFAULTS_IN_TWELVE_MONTHS]:
    'Exceeds paid commercial defaults in 12 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_DRAWDOWNS_INCLUSIVE]:
    'Exceeds payday account in 90 days drawdowns inclusive limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_DEFAULT_JUDGEMENTS]: 'Exceeds paid default judgements limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_PAID_DEFAULT_JUDGEMENTS_IN_TWELVE_MONTHS]:
    'Exceeds paid default judgements in 12 months limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_SIXTY_DAYS]:
    'Exceeds recent drawdown on unsecured facility in 60 days limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_NINETY_DAYS]:
    'Exceeds recent drawdown on unsecured facility in 90 days limit',
  [NON_ELIGIBILITY_CODE.NOT_WITHIN_SECURABLE_ASSET]: 'Not within securable asset limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DISHONOURS_IN_NINETY_DAYS]: 'Exceeds financial dishonours in 90 days limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DISHONOURS_IN_THIRTY_DAYS]: 'Exceeds financial dishonours in 30 days limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_EWF_CONDITIONS]: 'Exceeds EWF conditions limit',
  [NON_ELIGIBILITY_CODE.EXCEEDS_COMPLIANCE_CONDITIONS]: 'Exceeds Compliance conditions limit',
}

export enum RULE_FACTOR {
  AGE_OF_CREDIT_FILE = 'acf',
  APPLICANT_AGE = 'age',
  ASSET_TYPE = 'at',
  ATM_WITHDRAWALS = 'atm',
  ATM_WITHDRAWALS_PERCENT_INCOME = 'atmw2',
  BNPL = 'bnpl',
  BUSINESS_REGISTRATION_AND_DURATION = 'brd',
  BUYING_THROUGH = 'bt',
  COMMERCIAL_SCORE = 'ccsc',
  COMMERCIAL_DEFAULTS_IN_SIX_MONTHS = 'cd6m',
  NO_OF_CREDIT_ENQUIRIES_SIX_MONTHS = 'ce6m',
  COMMERCIAL_LOAN_TYPE = 'clt',
  COMPLIANCE = 'cmplc',
  COMMERCIAL_MAX_LOAN_AMOUNT = 'cmxla',
  CONSUMER_SCORE = 'csc',
  COMMERCIAL_VEHICLE_AGE = 'cvehage',
  DAYS_IN_NEGATIVE = 'daysinneg',
  DEBT_MANAGEMENT = 'debtmgmt',
  DEBT_CONSOLIDATION = 'debtcnsl',
  DEBT_COLLECTION_IN_NINETY_DAYS = 'debtcol90d',
  DEFAULT_JUDGEMENT = 'djg',
  EMPLOYMENT_TYPE_AND_DURATION = 'etd',
  FINANCIAL_DEFAULTS_IN_SIX_MONTHS = 'fd6m',
  FINANCIAL_HARDSHIP_INDICATOR = 'fhi',
  GAMBLING = 'gaminmprop',
  MINIMUM_GROSS_INCOME = 'gi',
  RHI_STATUS_IN_TWELVE_MONTHS = 'hrhi12m',
  RHI_STATUS_IN_TWENTY_FOUR_MONTHS = 'hrhi24m',
  RHI_STATUS_IN_THREE_MONTHS = 'hrhi3m',
  INCOME_VERIFICATION = 'iv',
  LOAN_TYPE = 'lt',
  MINIMUM_LOAN_AMOUNT = 'mnla',
  MAXIMUM_LOAN_AMOUNT = 'mxla',
  NO_CREDIT_FILE = 'ncf',
  MINIMUM_NET_INCOME = 'ni',
  NO_OF_DISHONOURS = 'numofdisho',
  NO_OF_DISHONOURS_IN_THIRTY_DAYS = 'numdisho30',
  NO_OF_OPEN_CREDIT_CARDS = 'nocc',
  NO_OF_OPEN_PERSONAL_LOANS = 'nopl',
  NO_OF_OPEN_VEHICLE_LOANS = 'novl',
  NO_OF_OPEN_MORTGAGES = 'nom',
  NON_FINANCIAL_DEFAULTS_IN_SIX_MONTHS = 'nfd6m',
  OUTSTANDING_COMMERCIAL_DEFAULT = 'ocd',
  OUTSTANDING_DEFAULT_JUDGEMENTS = 'odjg',
  OUTSTANDING_DEFAULT_JUDGEMENTS_NZ = 'odjg-nz',
  OUTSTANDING_FINANCIAL_DEFAULT = 'ofd',
  OUTSTANDING_NON_FINANCIAL_DEFAULT = 'onfd',
  OUTSTANDING_NON_FINANCIAL_DEFAULT_IN_LAST_YEAR = 'onfdly',
  PAID_COMMERCIAL_DEFAULTS = 'pcd',
  PAID_COMMERCIAL_DEFAULTS_IN_TWELVE_MONTHS = 'pcd12m',
  PAYDAY_ACCOUNT_IN_THIRTY_DAYS = 'pdac30',
  PAYDAY_ACCOUNT_IN_NINETY_DAYS = 'pdac90',
  PAYDAY_ACCOUNT_IN_NINETY_DAYS_NZ = 'pdac90-nz',
  PAYDAY_ACCOUNT_IN_NINETY_DAYS_DRAWDOWNS_INCLUSIVE = 'pdacdw90',
  PAYDAY_ENQUIRIES_IN_SIX_MONTHS = 'pden6m',
  PAYDAY_ENQUIRIES_IN_TWELVE_MONTHS = 'pden12m',
  PAYDAY_ENQUIRIES_IN_TWENTY_FOUR_MONTHS = 'pden24m',
  PAID_DEFAULT_JUDGEMENTS = 'pdjg',
  PAID_DEFAULT_JUDGEMENTS_IN_TWELVE_MONTHS = 'pdjg12m',
  POSSIBLE_MATCH = 'ps',
  PAYDAY_ENQUIRIES = 'pde',
  PAID_FINANCIAL_DEFAULT = 'pfd',
  PAID_FINANCIAL_DEFAULT_IN_LAST_YEAR = 'pfdly',
  PERSONAL_LOAN_PURPOSE = 'plp',
  PAID_NON_FINANCIAL_DEFAULT = 'pnfd',
  PAID_NON_FINANCIAL_DEFAULT_IN_LAST_YEAR = 'pnfdly',
  PARTNER_ID = 'pid',
  RESIDENCY = 'rsdy',
  RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_SIXTY_DAYS = 'rduf60',
  RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_NINETY_DAYS = 'rduf90',
  SECURABLE_ASSET = 'seca',
  SERVICEABILITY = 'srvc',
  THIN_FILE = 'thinf',
  FINANCIAL_DISHONOURS_IN_NINETY_DAYS = 'ufd',
  FINANCIAL_DISHONOURS_IN_THRITY_DAYS = 'ufd30',
  VEHICLE_AGE = 'vehage',
  WARRANTY_FINANCED = 'warrfin',
  EARLY_WAGE_FACILITIES = 'ewf',
}

export const RULE_FACTOR_TO_NON_ELIGIBILITY_CODE_MAP = {
  [RULE_FACTOR.AGE_OF_CREDIT_FILE]: NON_ELIGIBILITY_CODE.LOW_CREDIT_FILE_AGE,
  [RULE_FACTOR.APPLICANT_AGE]: NON_ELIGIBILITY_CODE.BELOW_MINIMUM_AGE,
  [RULE_FACTOR.ASSET_TYPE]: NON_ELIGIBILITY_CODE.CARS_ONLY,
  [RULE_FACTOR.BUSINESS_REGISTRATION_AND_DURATION]: NON_ELIGIBILITY_CODE.NOT_WITHIN_BUSINESS_DURATION,
  [RULE_FACTOR.BUYING_THROUGH]: NON_ELIGIBILITY_CODE.DEALER_ONLY,
  [RULE_FACTOR.COMMERCIAL_SCORE]: NON_ELIGIBILITY_CODE.LOW_CREDIT_SCORE,
  [RULE_FACTOR.NO_OF_CREDIT_ENQUIRIES_SIX_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_CREDIT_ENQUIRIES_LIMIT,
  [RULE_FACTOR.COMMERCIAL_LOAN_TYPE]: NON_ELIGIBILITY_CODE.COMMERCIAL_REFINANCE_NOT_ALLOWED,
  [RULE_FACTOR.COMMERCIAL_MAX_LOAN_AMOUNT]: NON_ELIGIBILITY_CODE.EXCEEDS_MAXIMUM_LOAN_AMOUNT,
  [RULE_FACTOR.CONSUMER_SCORE]: NON_ELIGIBILITY_CODE.LOW_CREDIT_SCORE,
  [RULE_FACTOR.COMMERCIAL_VEHICLE_AGE]: NON_ELIGIBILITY_CODE.EXCEEDS_VEHICLE_AGE_LIMIT,
  [RULE_FACTOR.COMPLIANCE]: NON_ELIGIBILITY_CODE.EXCEEDS_COMPLIANCE_CONDITIONS,
  [RULE_FACTOR.DAYS_IN_NEGATIVE]: NON_ELIGIBILITY_CODE.EXCEEDS_DAYS_IN_NEGATIVE_LIMIT,
  [RULE_FACTOR.DEBT_COLLECTION_IN_NINETY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_COLLECTION_NINETY_DAYS_LIMIT,
  [RULE_FACTOR.DEBT_CONSOLIDATION]: NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_CONSOLIDATION_LIMIT,
  [RULE_FACTOR.DEBT_MANAGEMENT]: NON_ELIGIBILITY_CODE.EXCEEDS_DEBT_MANAGEMENT_LIMIT,
  [RULE_FACTOR.DEFAULT_JUDGEMENT]: NON_ELIGIBILITY_CODE.EXCEEDS_DEFAULT_JUDGEMENT_LIMIT,
  [RULE_FACTOR.EMPLOYMENT_TYPE_AND_DURATION]: NON_ELIGIBILITY_CODE.NOT_WITHIN_EMPLOYMENT,
  [RULE_FACTOR.GAMBLING]: NON_ELIGIBILITY_CODE.EXCEEDS_GAMBLING_LIMIT,
  [RULE_FACTOR.MINIMUM_GROSS_INCOME]: NON_ELIGIBILITY_CODE.BELOW_GROSS_INCOME_LIMIT,
  [RULE_FACTOR.RHI_STATUS_IN_THREE_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_RHI_THREE_MONTHS_LIMIT,
  [RULE_FACTOR.RHI_STATUS_IN_TWELVE_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_RHI_TWELVE_MONTHS_LIMIT,
  [RULE_FACTOR.RHI_STATUS_IN_TWENTY_FOUR_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_RHI_TWENTY_FOUR_MONTHS_LIMIT,
  [RULE_FACTOR.LOAN_TYPE]: NON_ELIGIBILITY_CODE.REFINANCE_NOT_ALLOWED,
  [RULE_FACTOR.MINIMUM_LOAN_AMOUNT]: NON_ELIGIBILITY_CODE.BELOW_MINIMUM_LOAN_AMOUNT,
  [RULE_FACTOR.MAXIMUM_LOAN_AMOUNT]: NON_ELIGIBILITY_CODE.EXCEEDS_MAXIMUM_LOAN_AMOUNT,
  [RULE_FACTOR.NO_CREDIT_FILE]: NON_ELIGIBILITY_CODE.NO_CREDIT_FILE,
  [RULE_FACTOR.NO_OF_DISHONOURS]: NON_ELIGIBILITY_CODE.EXCEEDS_DISHONOURS_LIMIT,
  [RULE_FACTOR.NO_OF_DISHONOURS_IN_THIRTY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_DISHONOURS_LIMIT_IN_THIRTY_DAYS_LIMIT,
  [RULE_FACTOR.OUTSTANDING_FINANCIAL_DEFAULT]: NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_FINANCIAL_LIMIT,
  [RULE_FACTOR.OUTSTANDING_NON_FINANCIAL_DEFAULT]: NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_NON_FINANCIAL_LIMIT,
  [RULE_FACTOR.OUTSTANDING_NON_FINANCIAL_DEFAULT_IN_LAST_YEAR]:
    NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_FINANCIAL_LAST_YEAR_LIMIT,
  [RULE_FACTOR.PAYDAY_ACCOUNT_IN_THIRTY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_THIRTY_DAYS_LIMIT,
  [RULE_FACTOR.PAYDAY_ACCOUNT_IN_NINETY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_LIMIT,
  [RULE_FACTOR.PAYDAY_ACCOUNT_IN_NINETY_DAYS_NZ]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_LIMIT,
  [RULE_FACTOR.PAYDAY_ENQUIRIES_IN_SIX_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_SIX_MONTHS_LIMIT,
  [RULE_FACTOR.PAYDAY_ENQUIRIES_IN_TWELVE_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_TWELVE_MONTHS_LIMIT,
  [RULE_FACTOR.PAYDAY_ENQUIRIES_IN_TWENTY_FOUR_MONTHS]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_IN_TWENTY_FOUR_MONTHS_LIMIT,
  [RULE_FACTOR.PAYDAY_ENQUIRIES]: NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ENQUIRIES_LIMIT,
  [RULE_FACTOR.PAID_FINANCIAL_DEFAULT]: NON_ELIGIBILITY_CODE.EXCEEDS_PAID_FINANCIAL_DEFAULT_LIMIT,
  [RULE_FACTOR.PAID_FINANCIAL_DEFAULT_IN_LAST_YEAR]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAID_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT,
  [RULE_FACTOR.PAID_NON_FINANCIAL_DEFAULT]: NON_ELIGIBILITY_CODE.EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LIMIT,
  [RULE_FACTOR.PAID_NON_FINANCIAL_DEFAULT_IN_LAST_YEAR]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAID_NON_FINANCIAL_DEFAULT_LAST_YEAR_LIMIT,
  [RULE_FACTOR.PARTNER_ID]: NON_ELIGIBILITY_CODE.NON_VALID_PARTNER,
  [RULE_FACTOR.POSSIBLE_MATCH]: NON_ELIGIBILITY_CODE.EXCEEDS_POSSIBLE_MATCH_LIMIT,
  [RULE_FACTOR.RESIDENCY]: NON_ELIGIBILITY_CODE.RESIDENCY_STATUS,
  [RULE_FACTOR.SERVICEABILITY]: NON_ELIGIBILITY_CODE.BELOW_SERVICEABILITY_LIMIT,
  [RULE_FACTOR.VEHICLE_AGE]: NON_ELIGIBILITY_CODE.EXCEEDS_VEHICLE_AGE_LIMIT,
  [RULE_FACTOR.WARRANTY_FINANCED]: NON_ELIGIBILITY_CODE.WARRANTY_FINANCE_NOTSUPPORTED,
  [RULE_FACTOR.PERSONAL_LOAN_PURPOSE]: NON_ELIGIBILITY_CODE.NO_PERSONAL_LOAN,
  [RULE_FACTOR.THIN_FILE]: NON_ELIGIBILITY_CODE.NOT_WITHIN_THIN_FILE_LIMIT,
  [RULE_FACTOR.BNPL]: NON_ELIGIBILITY_CODE.EXCEEDS_BNPL_LIMIT,
  [RULE_FACTOR.ATM_WITHDRAWALS]: NON_ELIGIBILITY_CODE.EXCEEDS_ATM_WTIHDRAWALS,
  [RULE_FACTOR.ATM_WITHDRAWALS_PERCENT_INCOME]: NON_ELIGIBILITY_CODE.EXCEEDS_ATM_WTIHDRAWALS_PERCENT_INCOME,
  [RULE_FACTOR.COMMERCIAL_DEFAULTS_IN_SIX_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_COMMERCIAL_DEFAULTS_IN_SIX_MONTHS,
  [RULE_FACTOR.FINANCIAL_DEFAULTS_IN_SIX_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DEFAULTS_IN_SIX_MONTHS,
  [RULE_FACTOR.FINANCIAL_HARDSHIP_INDICATOR]: NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_HARDSHIP_INDICATOR,
  [RULE_FACTOR.INCOME_VERIFICATION]: NON_ELIGIBILITY_CODE.NOT_WITHIN_INCOME_VERIFICATION,
  [RULE_FACTOR.MINIMUM_NET_INCOME]: NON_ELIGIBILITY_CODE.NOT_WITHIN_MINIMUM_NET_INCOME,
  [RULE_FACTOR.NO_OF_OPEN_CREDIT_CARDS]: NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_CREDIT_CARDS,
  [RULE_FACTOR.NO_OF_OPEN_PERSONAL_LOANS]: NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_PERSONAL_LOANS,
  [RULE_FACTOR.NO_OF_OPEN_VEHICLE_LOANS]: NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_VEHICLE_LOANS,
  [RULE_FACTOR.NO_OF_OPEN_MORTGAGES]: NON_ELIGIBILITY_CODE.EXCEEDS_NO_OF_OPEN_MORTGAGES,
  [RULE_FACTOR.NON_FINANCIAL_DEFAULTS_IN_SIX_MONTHS]: NON_ELIGIBILITY_CODE.EXCEEDS_NON_FINANCIAL_DEFAULTS_IN_SIX_MONTHS,
  [RULE_FACTOR.OUTSTANDING_COMMERCIAL_DEFAULT]: NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_COMMERCIAL_DEFAULT,
  [RULE_FACTOR.OUTSTANDING_DEFAULT_JUDGEMENTS]: NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_DEFAULT_JUDGEMENT,
  [RULE_FACTOR.OUTSTANDING_DEFAULT_JUDGEMENTS_NZ]: NON_ELIGIBILITY_CODE.EXCEEDS_OUTSTANDING_DEFAULT_JUDGEMENT,
  [RULE_FACTOR.PAID_COMMERCIAL_DEFAULTS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAID_COMMERCIAL_DEFAULTS,
  [RULE_FACTOR.PAID_COMMERCIAL_DEFAULTS_IN_TWELVE_MONTHS]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAID_COMMERCIAL_DEFAULTS_IN_TWELVE_MONTHS,
  [RULE_FACTOR.PAYDAY_ACCOUNT_IN_NINETY_DAYS_DRAWDOWNS_INCLUSIVE]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAYDAY_ACCOUNT_IN_NINETY_DAYS_DRAWDOWNS_INCLUSIVE,
  [RULE_FACTOR.PAID_DEFAULT_JUDGEMENTS]: NON_ELIGIBILITY_CODE.EXCEEDS_PAID_DEFAULT_JUDGEMENTS,
  [RULE_FACTOR.PAID_DEFAULT_JUDGEMENTS_IN_TWELVE_MONTHS]:
    NON_ELIGIBILITY_CODE.EXCEEDS_PAID_DEFAULT_JUDGEMENTS_IN_TWELVE_MONTHS,
  [RULE_FACTOR.RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_SIXTY_DAYS]:
    NON_ELIGIBILITY_CODE.EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_SIXTY_DAYS,
  [RULE_FACTOR.RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_NINETY_DAYS]:
    NON_ELIGIBILITY_CODE.EXCEEDS_RECENT_DRAWDOWN_ON_UNSECURED_FACILITY_IN_NINETY_DAYS,
  [RULE_FACTOR.SECURABLE_ASSET]: NON_ELIGIBILITY_CODE.NOT_WITHIN_SECURABLE_ASSET,
  [RULE_FACTOR.FINANCIAL_DISHONOURS_IN_NINETY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DISHONOURS_IN_NINETY_DAYS,
  [RULE_FACTOR.FINANCIAL_DISHONOURS_IN_THRITY_DAYS]: NON_ELIGIBILITY_CODE.EXCEEDS_FINANCIAL_DISHONOURS_IN_THIRTY_DAYS,
  [RULE_FACTOR.EARLY_WAGE_FACILITIES]: NON_ELIGIBILITY_CODE.EXCEEDS_EWF_CONDITIONS,
}

export enum RULE_CATEGORY {
  APPLICATION = 100,
  CONDITIONAL = 200,
  BANK = 300,
  BANK_NON_CONDITIONAL = 350,
  CREDIT = 400,
  DOCUMENT = 500,
}

export const MESSAGE_TYPE = {
  INSTANT_QUOTE: 'InstantQuote',
  PARTIAL_QUOTE: 'PartialQuote',
}

export const APPLICATION_ORIGIN = {
  QUOTE: 'quote',
  API: 'api',
  PARTIAL: 'partial',
}

export enum ASSESSMENT_STATUS {
  // Original statuses
  NONE = 'none',
  STARTED = 'started',
  PENDING = 'pending', // to be replace by awaiting_confirmation
  COMPLETE = 'complete', // lender is switched and no confirmation required
  CONFIRMED = 'confirmed', // after pending
  INELIGIBLE = 'ineligible',
  FAILED = 'failed',
  TIMEOUT = 'timeout',

  // New Assessment statuses, to be used for No Bank Statements
  PROCESSING_CREDIT_ASSESSMENT = 'processing_credit_assessment',
  AWAITING_BANK_STATEMENTS = 'awaiting_bank_statements',
  PROCESSING_BANK_ASSESSMENT = 'processing_bank_assessment',
  AWAITING_CONFIRMATION = 'awaiting_confirmation', // will replace 'pending'
}

export enum ACTIONS_TO_COLLECT_DEBT {
  NO_FULLY_REPAID = 'No, all fully repaid now',
  NO_DEBT_ARRANGEMENT = 'Yes, but not under a debt collection arrangement',
  DEBT_ARRANGEMENT = 'Yes, still under debt collection arrangement',
}

export enum GENERATED_QUOTE_STATUS {
  CREATED = 'created',
  VERIFIED = 'verified',
  COMPLETE = 'complete',
}

export * from './aiDocumentReader'
// THIS needs to be at the bottom for now until we move the rest of the types out of this file.
export * from './analyticsEvents'
export { LENDER_STATUS, LoanOptionsPricing, PartnerLenderOption, SubmitAndPriceResponse } from './apiContracts'
export * from './assessmentInsights'
export * from './assetCondition'
export * from './assetType'
export * from './attribution'
export * from './authZero'
export * from './buyingThrough'
export { CENTRIX_BUREAU_META, CENTRIX_META } from './centrix'
export * from './creditData'
export * from './currency'
export * from './customerIo'
export * from './debtConsolidationOptions'
export * from './documentData'
export * from './dynamicDocs'
export * from './employmentStatus'
export * from './endOfTermChange'
export * from './env'
export { EQUIFAX_ACCOUNT_TYPE, EQUIFAX_BUREAU_META, EQUIFAX_META } from './equifax'
export * from './featureFlags'
export * from './gender'
export * from './gfv'
export * from './incomeType'
export * from './industry'
export * from './instantQuote'
export * from './lambdaInvocationType'
export * from './leaseBreakdown'
export * from './lenderInfo'
export * from './lenders'
export * from './liabilityVerification'
export * from './licenceType'
export * from './livingSituation'
export * from './loanApplication'
export * from './loanApplicationFiles'
export * from './loanApplicationPricingResultDataObject'
export * from './lodgement'
export * from './motivResultType'
export * from './motivType'
export * from './motivTypeGroup'
export * from './partners'
export * from './personalLoanPurpose'
export * from './preApprovalStatus'
export * from './region'
export * from './relationshipStatus'
export * from './residencyStatus'
export * from './returnType'
export * from './shortUrlType'
export * from './smartLodgementEngine'
export * from './state'
export * from './title'
export * from './tradeIn'
export * from './vehicleState'
export * from './vehicleType'
